export default function FlatAllowanceIcon () {
  return (
    <svg
      width={140}
      height={106}
      className='max-w-full'
      viewBox='0 0 140 106'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <rect x={58} y={7} width={24} height={24} rx={4} fill='#E5E5E5' />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M70.0002 11.6666C70.3684 11.6666 70.6668 11.9651 70.6668 12.3333V25.6666C70.6668 26.0348 70.3684 26.3333 70.0002 26.3333C69.632 26.3333 69.3335 26.0348 69.3335 25.6666V12.3333C69.3335 11.9651 69.632 11.6666 70.0002 11.6666Z'
        fill='#6E6E6E'
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M66.2122 14.5453C66.7748 13.9827 67.5378 13.6666 68.3335 13.6666H73.3335C73.7017 13.6666 74.0002 13.9651 74.0002 14.3333C74.0002 14.7015 73.7017 15 73.3335 15H68.3335C67.8915 15 67.4675 15.1756 67.155 15.4881C66.8424 15.8007 66.6668 16.2246 66.6668 16.6666C66.6668 17.1087 66.8424 17.5326 67.155 17.8451C67.4675 18.1577 67.8915 18.3333 68.3335 18.3333H71.6668C72.4625 18.3333 73.2255 18.6494 73.7882 19.212C74.3508 19.7746 74.6668 20.5376 74.6668 21.3333C74.6668 22.1289 74.3508 22.892 73.7882 23.4546C73.2255 24.0172 72.4625 24.3333 71.6668 24.3333H66.0002C65.632 24.3333 65.3335 24.0348 65.3335 23.6666C65.3335 23.2984 65.632 23 66.0002 23H71.6668C72.1089 23 72.5328 22.8244 72.8453 22.5118C73.1579 22.1992 73.3335 21.7753 73.3335 21.3333C73.3335 20.8913 73.1579 20.4673 72.8453 20.1548C72.5328 19.8422 72.1089 19.6666 71.6668 19.6666H68.3335C67.5378 19.6666 66.7748 19.3506 66.2122 18.7879C65.6496 18.2253 65.3335 17.4623 65.3335 16.6666C65.3335 15.871 65.6496 15.1079 66.2122 14.5453Z'
        fill='#6E6E6E'
      />
      <path
        d='M70 31V53M70 53V70M70 53C70 55.5 72 57.4 74.5 57.4H123.5C125.709 57.4 127.5 59.1909 127.5 61.4V70M70 53C70 55.5 68 57.4 65.5 57.4H16.5C14.2909 57.4 12.5 59.1909 12.5 61.4V70'
        stroke='url(#paint0_linear_1336_28027)'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M12.5 71C7.52944 71 3.5 75.0294 3.5 80C3.5 84.9706 7.52944 89 12.5 89C17.4706 89 21.5 84.9706 21.5 80C21.5 75.0294 17.4706 71 12.5 71ZM1.5 80C1.5 73.9249 6.42487 69 12.5 69C18.5751 69 23.5 73.9249 23.5 80C23.5 86.0751 18.5751 91 12.5 91C6.42487 91 1.5 86.0751 1.5 80Z'
        fill='#6E6E6E'
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M12.5 76C11.3954 76 10.5 76.8954 10.5 78C10.5 79.1046 11.3954 80 12.5 80C13.6046 80 14.5 79.1046 14.5 78C14.5 76.8954 13.6046 76 12.5 76ZM8.5 78C8.5 75.7909 10.2909 74 12.5 74C14.7091 74 16.5 75.7909 16.5 78C16.5 80.2091 14.7091 82 12.5 82C10.2909 82 8.5 80.2091 8.5 78Z'
        fill='#6E6E6E'
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M9.5 86C9.23478 86 8.98043 86.1054 8.79289 86.2929C8.60536 86.4804 8.5 86.7348 8.5 87V88.662C8.5 89.2143 8.05228 89.662 7.5 89.662C6.94772 89.662 6.5 89.2143 6.5 88.662V87C6.5 86.2043 6.81607 85.4413 7.37868 84.8787C7.94129 84.3161 8.70435 84 9.5 84H15.5C16.2957 84 17.0587 84.3161 17.6213 84.8787C18.1839 85.4413 18.5 86.2043 18.5 87V88.662C18.5 89.2143 18.0523 89.662 17.5 89.662C16.9477 89.662 16.5 89.2143 16.5 88.662V87C16.5 86.7348 16.3946 86.4804 16.2071 86.2929C16.0196 86.1054 15.7652 86 15.5 86H9.5Z'
        fill='#6E6E6E'
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M70 71C65.0294 71 61 75.0294 61 80C61 84.9706 65.0294 89 70 89C74.9706 89 79 84.9706 79 80C79 75.0294 74.9706 71 70 71ZM59 80C59 73.9249 63.9249 69 70 69C76.0751 69 81 73.9249 81 80C81 86.0751 76.0751 91 70 91C63.9249 91 59 86.0751 59 80Z'
        fill='#6E6E6E'
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M70 76C68.8954 76 68 76.8954 68 78C68 79.1046 68.8954 80 70 80C71.1046 80 72 79.1046 72 78C72 76.8954 71.1046 76 70 76ZM66 78C66 75.7909 67.7909 74 70 74C72.2091 74 74 75.7909 74 78C74 80.2091 72.2091 82 70 82C67.7909 82 66 80.2091 66 78Z'
        fill='#6E6E6E'
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M67 86C66.7348 86 66.4804 86.1054 66.2929 86.2929C66.1054 86.4804 66 86.7348 66 87V88.662C66 89.2143 65.5523 89.662 65 89.662C64.4477 89.662 64 89.2143 64 88.662V87C64 86.2043 64.3161 85.4413 64.8787 84.8787C65.4413 84.3161 66.2043 84 67 84H73C73.7957 84 74.5587 84.3161 75.1213 84.8787C75.6839 85.4413 76 86.2043 76 87V88.662C76 89.2143 75.5523 89.662 75 89.662C74.4477 89.662 74 89.2143 74 88.662V87C74 86.7348 73.8946 86.4804 73.7071 86.2929C73.5196 86.1054 73.2652 86 73 86H67Z'
        fill='#6E6E6E'
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M127.5 71C122.529 71 118.5 75.0294 118.5 80C118.5 84.9706 122.529 89 127.5 89C132.471 89 136.5 84.9706 136.5 80C136.5 75.0294 132.471 71 127.5 71ZM116.5 80C116.5 73.9249 121.425 69 127.5 69C133.575 69 138.5 73.9249 138.5 80C138.5 86.0751 133.575 91 127.5 91C121.425 91 116.5 86.0751 116.5 80Z'
        fill='#6E6E6E'
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M127.5 76C126.395 76 125.5 76.8954 125.5 78C125.5 79.1046 126.395 80 127.5 80C128.605 80 129.5 79.1046 129.5 78C129.5 76.8954 128.605 76 127.5 76ZM123.5 78C123.5 75.7909 125.291 74 127.5 74C129.709 74 131.5 75.7909 131.5 78C131.5 80.2091 129.709 82 127.5 82C125.291 82 123.5 80.2091 123.5 78Z'
        fill='#6E6E6E'
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M124.5 86C124.235 86 123.98 86.1054 123.793 86.2929C123.605 86.4804 123.5 86.7348 123.5 87V88.662C123.5 89.2143 123.052 89.662 122.5 89.662C121.948 89.662 121.5 89.2143 121.5 88.662V87C121.5 86.2043 121.816 85.4413 122.379 84.8787C122.941 84.3161 123.704 84 124.5 84H130.5C131.296 84 132.059 84.3161 132.621 84.8787C133.184 85.4413 133.5 86.2043 133.5 87V88.662C133.5 89.2143 133.052 89.662 132.5 89.662C131.948 89.662 131.5 89.2143 131.5 88.662V87C131.5 86.7348 131.395 86.4804 131.207 86.2929C131.02 86.1054 130.765 86 130.5 86H124.5Z'
        fill='#6E6E6E'
      />
      <defs>
        <linearGradient
          id='paint0_linear_1336_28027'
          x1={70}
          y1={31}
          x2={70}
          y2={70}
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#E5E5E5' />
          <stop offset={1} stopColor='#919191' />
        </linearGradient>
      </defs>
    </svg>
  )
}
